import { Bell, Bookmark, EyeOff, Heart, History, Inbox, MessageSquareCheck, UserRound } from 'lucide-react';

export const USER_NAV_HREFS = {
  // HotPads brands the renter-conversation surface as "Messages" at `/messages`. The internal
  // nav key stays `inbox` because changing it would ripple through every consumer's i18n key
  // map — only the visible href + label change.
  inbox: '/messages',
  profile: '/user',
  notifications: '/user/settings',
  viewed: '/user/history',
  favorites: '/user/listings',
  hidden: '/user/listings/hidden',
  contacted: '/user/listings/contacted',
  savedSearches: '/user/searches',
} as const;

export type UserNavKey = keyof typeof USER_NAV_HREFS;

export const USER_NAV_ORDER = [
  'profile',
  'favorites',
  'savedSearches',
  'viewed',
  'notifications',
] as const satisfies ReadonlyArray<UserNavKey>;

export const USER_ACCOUNT_NAV_ORDER = [
  'favorites',
  'savedSearches',
  'viewed',
  'notifications',
] as const satisfies ReadonlyArray<UserNavKey>;

export const USER_NAV_ICONS = {
  inbox: Inbox,
  profile: UserRound,
  notifications: Bell,
  viewed: History,
  favorites: Heart,
  hidden: EyeOff,
  contacted: MessageSquareCheck,
  savedSearches: Bookmark,
} as const;
